export enum AddressFieldName {
  ADDRESS = 'address',
  ADDRESS_LINE_2 = 'addressLine2',
  ADDRESS_LINE_3 = 'addressLine3',
  ADDRESS_LINE_4 = 'addressLine4',
  CITY = 'city',
  CITY_FRENCH = 'cityFrench',
  CUSTOM_TOWN = 'customTown',
  COUNTRY = 'country',
  COUNTY = 'county',
  HOUSE_NUMBER = 'houseNumber',
  HOUSE_NUMBER_ADDITION = 'houseNumberAddition',
  POSTCODE = 'postCode',
  ZIP_CODE = 'zipCode',
  STATE = 'state',
  STATE_ISO = 'stateIso',
  FINDER = 'finder',
}
